// Recommended Products catalog + metadata.
// Transcribed from the design export (products-data.js + RecommendedProducts.jsx).
// Static frontend catalog — no backend involved.
import ToysOutlined from '@mui/icons-material/ToysOutlined';
import PetsOutlined from '@mui/icons-material/PetsOutlined';
import CookieOutlined from '@mui/icons-material/CookieOutlined';
import ContentCutOutlined from '@mui/icons-material/ContentCutOutlined';
import HealthAndSafetyOutlined from '@mui/icons-material/HealthAndSafetyOutlined';
import ShieldOutlined from '@mui/icons-material/ShieldOutlined';
import FitnessCenterOutlined from '@mui/icons-material/FitnessCenterOutlined';
import RestaurantOutlined from '@mui/icons-material/RestaurantOutlined';
import CleaningServicesOutlined from '@mui/icons-material/CleaningServicesOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';

export type Pet = 'Dog' | 'Cat';

export type Product = {
  name: string;
  link: string;
  type: string;
  focus: string;
  price: string;
};

type MuiIcon = typeof ToysOutlined;

export const DOG_PRODUCTS: Product[] = [
  {
 name: 'ThunderEase Calming Pheromone Diffuser', link: 'https://chewy.sjv.io/vDQx1e', type: 'Health', focus: 'Anxiety', price: '$25',
},
  {
 name: 'ThunderShirt Classic Anxiety & Calming Vest', link: 'https://chewy.sjv.io/aOJDAW', type: 'Health', focus: 'Anxiety', price: '$40',
},
  {
 name: 'Benebone Wishbone Tough Chew Toy', link: 'https://chewy.sjv.io/e1oQYD', type: 'Chews', focus: 'Chewing', price: '$14',
},
  {
 name: 'Woodies Coffee Wood Large Dog Chew', link: 'https://chewy.sjv.io/qzR0Mg', type: 'Chews', focus: 'Chewing', price: '$17',
},
  {
 name: 'KONG Classic Dog Toy', link: 'https://chewy.sjv.io/gOzL0v', type: 'Toys', focus: 'Chewing', price: '$14',
},
  {
 name: 'Outward Hound Orbee-Tuff Snoop Treat Dispensing Dog Chew', link: 'https://chewy.sjv.io/09rneP', type: 'Work to Eat', focus: 'Mental Enrichment', price: '$13',
},
  {
 name: 'LickiMat Yoggie Pot BPA-Free Rubber Dog Bowl', link: 'https://chewy.sjv.io/bOZqEP', type: 'Work to Eat', focus: 'Mental Enrichment', price: '$24',
},
  {
 name: 'Woof BullySafe Dog Chew Treat Holder', link: 'https://chewy.sjv.io/XmPrV4', type: 'Safety Equipment', focus: 'Chewing', price: '$20',
},
  {
 name: 'Gentle Creatures Collar Companion - Harness to Collar Safety Clip', link: 'https://www.amazon.com/Gentle-Creatures-Collar-Companion-Adjustable/dp/B08JQ3WYXC', type: 'Safety Equipment', focus: 'Safety & Management', price: '$9',
},
  {
 name: 'Best Pet Supplies Oatmeal Unscented Grooming Wipes', link: 'https://chewy.sjv.io/QjqGkM', type: 'Grooming Tools', focus: 'Grooming', price: '$10',
},
  {
 name: 'KONG Dog ZoomGroom Multi-Use Brush', link: 'https://chewy.sjv.io/YR5jZm', type: 'Grooming Tools', focus: 'Grooming', price: '$14',
},
  {
 name: 'Squishy Face Studio Flirt Pole V2 with Lure Squeaky Dog Toy', link: 'https://chewy.sjv.io/GK6QLr', type: 'Toys', focus: 'Herding', price: '$29',
},
  {
 name: 'Jolly Pets Jolly Egg Dog Toy', link: 'https://chewy.sjv.io/kOnkxn', type: 'Toys', focus: 'Herding', price: '$21',
},
  {
 name: 'Jolly Pets Push-n-Play Ball', link: 'https://chewy.sjv.io/aOJLEb', type: 'Toys', focus: 'Herding', price: '$28',
},
  {
 name: 'Nerf Dog Squeak Ball Dog Toy', link: 'https://chewy.sjv.io/L0OXxL', type: 'Toys', focus: 'Herding', price: '$16',
},
  {
 name: 'iFetch iDig Stay Dog Toy', link: 'https://chewy.sjv.io/19jg4a', type: 'Toys', focus: 'Digging', price: '$99',
},
  {
 name: 'ZippyPaws Burrow Squeaky Hide & Seek Plush Dog Toy', link: 'https://chewy.sjv.io/eneKND', type: 'Toys', focus: 'Digging', price: '$32',
},
  {
 name: 'Octagon 6.5 ft. x 7 ft. Wood Sandbox Kit with Cover', link: 'https://www.homedepot.com/pep/Creative-Cedar-Designs-Octagon-6-5-ft-x-7-ft-Wood-Sandbox-Kit-with-Cover-7120/301138272', type: 'Equipment', focus: 'Digging', price: '$150',
},
  {
 name: 'Outward Hound Medium Slow Feeder Bowl', link: 'https://chewy.sjv.io/kOnXD3', type: 'Work to Eat', focus: 'Mental Enrichment', price: '$9',
},
  {
 name: 'GOOPAWS Silicone Dog Lick Mat (2 Count)', link: 'https://chewy.sjv.io/raveKB', type: 'Work to Eat', focus: 'Anxiety', price: '$20',
},
  {
 name: 'Pet Parents Forager Snuffle Mat', link: 'https://chewy.sjv.io/9L1xkY', type: 'Work to Eat', focus: 'Digging', price: '$22',
},
  {
 name: 'Stashios Soothing Saucer Dog Toy', link: 'https://chewy.sjv.io/vPL07O', type: 'Work to Eat', focus: 'Anxiety', price: '$29',
},
  {
 name: 'Virbac C.E.T. Enzymatic Oral Hygiene Poultry Flavor Dog Dental Kit', link: 'https://chewy.sjv.io/POLA5X', type: 'Grooming Tools', focus: 'Grooming', price: '$15',
},
  {
 name: 'Rinse Ace Suction Grooming Lick Pad Dog Grooming Tool', link: 'https://chewy.sjv.io/MK2n7P', type: 'Work to Eat', focus: 'Grooming', price: '$8',
},
  {
 name: 'West Paw Zogoflex Toppl Tough Treat Dispensing Dog Toy', link: 'https://chewy.sjv.io/OeNajz', type: 'Work to Eat', focus: 'Mental Enrichment', price: '$21',
},
  {
 name: 'Pet Gates', link: 'https://chewy.sjv.io/7aAL7g', type: 'Safety Equipment', focus: 'Safety & Management', price: 'Starting at $25',
},
  {
 name: 'Multipet Lamb Chop Squeaky Plush Dog Toy', link: 'https://chewy.sjv.io/nXOj5R', type: 'Toys', focus: 'Teething', price: '$9',
},
  {
 name: 'Nylabone Puppy Pacifier Teething Toy', link: 'https://chewy.sjv.io/jeED9b', type: 'Toys', focus: 'Teething', price: '$10',
},
  {
 name: 'Nylabone Teething Ring Puppy Chew Toy', link: 'https://chewy.sjv.io/vPL1JW', type: 'Toys', focus: 'Teething', price: '$12',
},
  {
 name: 'Petstages Cool Teething Stick', link: 'https://chewy.sjv.io/POLY7j', type: 'Toys', focus: 'Teething', price: '$5',
},
  {
 name: 'Baskerville Ultra Dog Adjustable Basket Muzzle', link: 'https://chewy.sjv.io/2aPgZa', type: 'Safety Equipment', focus: 'Safety & Management', price: 'Starting at $19',
},
  {
 name: 'Stewart Beef Liver Single Ingredient Freeze-Dried Raw Treats', link: 'https://chewy.sjv.io/WyjJkn', type: 'Treats', focus: 'Training', price: '$12',
},
  {
 name: 'PET N PET Dog Training Treat Pouch', link: 'https://chewy.sjv.io/DyErvy', type: 'Training Equipment', focus: 'Training', price: '$17',
},
  {
 name: 'Downtown Pet Supply Training Dog Clickers (2 Count)', link: 'https://chewy.sjv.io/VxrRkk', type: 'Training Equipment', focus: 'Training', price: '$12',
},
  {
 name: 'MidWest iCrate Fold & Carry Single Door Collapsible Wire Crate', link: 'https://chewy.sjv.io/9L1x20', type: 'Training Equipment', focus: 'Safety & Management', price: 'Starting at $33',
},
  {
 name: 'Cloud Star Tricky Trainers with Liver Soft & Chewy Dog Treats', link: 'https://chewy.sjv.io/55emJD', type: 'Treats', focus: 'Training', price: '$14',
},
  {
 name: '2 Hounds Design Freedom No Pull Nylon Dog Harness & Leash', link: 'https://chewy.sjv.io/09rnvE', type: 'Training Equipment', focus: 'Walks', price: '$46',
},
  {
 name: 'PetSafe Cotton Dog Training Lead, Black, 20-ft long', link: 'https://chewy.sjv.io/rELQGy', type: 'Training Equipment', focus: 'Walks', price: '$17',
},
  {
 name: 'Pawtitas Reflective Dog Leash, 6-ft long', link: 'https://chewy.sjv.io/MA419Y', type: 'Training Equipment', focus: 'Walks', price: '$24',
},
  {
 name: 'WAUDOG Waterproof Dog Leash, 10-ft long', link: 'https://chewy.sjv.io/gRq1D2', type: 'Training Equipment', focus: 'Walks', price: '$42',
},
];

export const CAT_PRODUCTS: Product[] = [
  {
 name: 'Raw Paws Silvervine Sticks Cat Chew Toy (30 Count)', link: 'https://chewy.sjv.io/QjqzxA', type: 'Treats', focus: 'Chewing', price: '$14',
},
  {
 name: 'Pet Greens Live Grass Cat Treat (3 Count)', link: 'https://chewy.sjv.io/dOX3Aj', type: 'Treats', focus: 'Chewing', price: '$25',
},
  {
 name: 'Potaroma Silvervine Stick Cat Chew Toys (6 Count)', link: 'https://chewy.sjv.io/0GyxNY', type: 'Chews', focus: 'Chewing', price: '$12',
},
  {
 name: 'Potaroma Chew Ropes Cat Toy (3 Count)', link: 'https://chewy.sjv.io/n4PRQR', type: 'Chews', focus: 'Chewing', price: '$8',
},
  {
 name: 'Best Pet Supplies Oatmeal Unscented Grooming Wipes', link: 'https://chewy.sjv.io/QjqGkM', type: 'Grooming Tools', focus: 'Grooming', price: '$10',
},
  {
 name: 'KONG Cat ZoomGroom Multi-Use Brush', link: 'https://chewy.sjv.io/aOJYZZ', type: 'Grooming Tools', focus: 'Grooming', price: '$8',
},
  {
 name: 'Catit Senses 2.0 Self Groomer Cat Brush', link: 'https://chewy.sjv.io/jeEDj5', type: 'Grooming Tools', focus: 'Grooming', price: '$7',
},
  {
 name: 'TRIXIE Self Grooming Arch & Cat Massager', link: 'https://chewy.sjv.io/kOnQPN', type: 'Grooming Tools', focus: 'Grooming', price: '$15',
},
  {
 name: 'K&H Pet Products Window Lounger Cat Perch Kitty Window Sill', link: 'https://chewy.sjv.io/DyEAJj', type: 'Equipment', focus: 'Home Set-Up', price: '$45',
},
  {
 name: 'Petlibro Air Wi-Fi Automatic Dog & Cat Feeder', link: 'https://chewy.sjv.io/4GkRRM', type: 'Health', focus: 'Home Set-Up', price: '$70',
},
  {
 name: 'Petlibro Dockstream 2 Smart Stainless Steel Cat Water Fountain', link: 'https://chewy.sjv.io/kOnQQn', type: 'Health', focus: 'Home Set-Up', price: '$80',
},
  {
 name: 'Pet Gates', link: 'https://chewy.sjv.io/7aAL7g', type: 'Safety Equipment', focus: 'Home Set-Up', price: 'Starting at $25',
},
  {
 name: 'Potaroma Catnip Crinkle Kicker Plush Cat Toy (3 Count)', link: 'https://chewy.sjv.io/nXOjV7', type: 'Toys', focus: 'Independent Play', price: '$9',
},
  {
 name: 'Frisco Foldable Play Tri-Tunnel Cat Toy', link: 'https://chewy.sjv.io/55em32', type: 'Toys', focus: 'Independent Play', price: '$13',
},
  {
 name: 'Mad Cat Big Cactus Kicker Catnip & Silvervine Cat Toy', link: 'https://chewy.sjv.io/WyjJEM', type: 'Toys', focus: 'Independent Play', price: '$13',
},
  {
 name: 'Earthtone Solutions Felted Wool Cat Ball Toy (6 Count)', link: 'https://chewy.sjv.io/POLY96', type: 'Toys', focus: 'Independent Play', price: '$12',
},
  {
 name: 'Cat Dancer Cat Charmer Toy (2 Pack)', link: 'https://chewy.sjv.io/e1oJZO', type: 'Toys', focus: 'Interactive Play', price: '$14',
},
  {
 name: 'Frisco Colorful Springs Cat Toy (40 Count)', link: 'https://chewy.sjv.io/qzRkGy', type: 'Toys', focus: 'Interactive Play', price: '$11',
},
  {
 name: 'Frisco Bird with Feathers Teaser Wand Cat Toy with Catnip', link: 'https://chewy.sjv.io/xLxX6v', type: 'Toys', focus: 'Interactive Play', price: '$6',
},
  {
 name: 'Pet Fit For Life Cat Wands Toy', link: 'https://chewy.sjv.io/LKvoYZ', type: 'Toys', focus: 'Interactive Play', price: '$10',
},
  {
 name: "Nature's Miracle Cat Urine Destroyer Plus Enzymatic Stain Remover Foam Aerosol Spray", link: 'https://chewy.sjv.io/EEnGVP', type: 'Cleaning', focus: 'Litter Box', price: '$9',
},
  {
 name: "Nature's Miracle Cat Urine Destroyer Plus Enzymatic Formula Stain Remover", link: 'https://chewy.sjv.io/POLAxR', type: 'Cleaning', focus: 'Litter Box', price: '$13',
},
  {
 name: 'allforpaws Go Fresh Stainless Steel Base Cat Litter Box', link: 'https://chewy.sjv.io/qzRkkj', type: 'Equipment', focus: 'Litter Box', price: '$32',
},
  {
 name: 'Tidy Cats Free & Clean Unscented Clumping Clay Cat Litter', link: 'https://chewy.sjv.io/o42PWO', type: 'Equipment', focus: 'Litter Box', price: '$10',
},
  {
 name: 'Coziwow Wall Mounted Shelves Set Cat Tree', link: 'https://chewy.sjv.io/LKvoWj', type: 'Equipment', focus: 'Scratching', price: '$70',
},
  {
 name: 'Necoichi Cozy Cat Scratcher Bowl Toy', link: 'https://chewy.sjv.io/enerz1', type: 'Equipment', focus: 'Scratching', price: '$39',
},
  {
 name: 'Frisco 33-in Heavy Duty Sisal Cat Scratching Post', link: 'https://chewy.sjv.io/m4jZGO', type: 'Equipment', focus: 'Scratching', price: '$35',
},
  {
 name: 'Frisco Double-Wide Cat Scratcher Toy with Catnip', link: 'https://chewy.sjv.io/m4jXM7', type: 'Equipment', focus: 'Scratching', price: '$10',
},
  {
 name: 'Inaba Churu Tuna & Chicken Puree Variety Pack Lickable Cat Treat', link: 'https://chewy.sjv.io/6yaK0m', type: 'Treats', focus: 'Training Essentials', price: '$32',
},
  {
 name: 'Whole Life Just One Ingredient Tuna Cat Treat', link: 'https://chewy.sjv.io/qWmZZj', type: 'Treats', focus: 'Training Essentials', price: '$14',
},
  {
 name: 'Downtown Pet Supply Training Clickers (2 Count)', link: 'https://chewy.sjv.io/VxrRkk', type: 'Training Equipment', focus: 'Training Essentials', price: '$6',
},
  {
 name: 'PetSafe Come with Me Kitty Nylon Cat Harness & Bungee Leash', link: 'https://chewy.sjv.io/55emzj', type: 'Equipment', focus: 'Training Essentials', price: '$18',
},
  {
 name: "Doc & Phoebe's Cat Co. Indoor Hunting Cat Feeder Kit", link: 'https://chewy.sjv.io/GK6o2V', type: 'Work to Eat', focus: 'Work to Eat', price: '$25',
},
  {
 name: 'Catstages Kitty Cube Cat Interactive Treat Puzzle Toy', link: 'https://chewy.sjv.io/raveN3', type: 'Work to Eat', focus: 'Work to Eat', price: '$13',
},
  {
 name: 'LickiMat Slomo Non-Skid Thermoplastic Rubber Cat Bowl', link: 'https://chewy.sjv.io/Z6kJRq', type: 'Work to Eat', focus: 'Work to Eat', price: '$17',
},
  {
 name: 'PetSafe SlimCat Interactive Cat Feeder', link: 'https://chewy.sjv.io/7aALQA', type: 'Work to Eat', focus: 'Work to Eat', price: '$9',
},
];

// Optional display-title overrides for section headers (keyed by raw focus value).
const TITLE_OVERRIDE: Record<string, string> = {
  'Mental Enrichment': 'Work to Eat',
  Training: 'Training Essentials',
};
export const sectionTitle = (focus: string): string => TITLE_OVERRIDE[focus] || focus || 'Other';

// Focus-area descriptive blurbs.
const FOCUS_SUB: Record<string, string> = {
  Anxiety: 'Products that can help reduce stress and support a calmer, more relaxed pet.',
  Chewing: 'Safe, satisfying options that redirect chewing in a positive way.',
  Teething: 'Soothing chews for puppies working through the teething stage.',
  Digging: 'Give natural digging instincts a safe, appropriate outlet.',
  'Mental Enrichment': 'Bowls and feeders that keep busy minds engaged.',
  Training: 'Products that support reward-based training and help reinforce desired behaviors.',
  Walks: 'Equipment for safe, enjoyable walks.',
  Grooming: 'Keep your pet clean and comfortable at home.',
  Herding: 'Outlets for high-energy, instinct-driven play.',
  'Safety & Management': 'Gear that keeps your dog secure, contained, and managed safely.',
  'Litter Box': 'Solutions for a cleaner, happier litter routine.',
  Scratching: 'Give claws a healthy, appropriate outlet.',
  'Independent Play': 'Toys that entertain when you are busy.',
  'Interactive Play': 'Bonding play you and your pet enjoy together.',
  'Home Set-Up': 'Essentials to set up a safe, comfortable space at home.',
  'Training Essentials': 'Tools that support reward-based training and good habits.',
  'Work to Eat': 'Feeders and puzzles that turn mealtime into enrichment.',
};
const DEFAULT_SUB = 'Everyday essentials for a happy, healthy pet.';

// Cat-specific blurb overrides (keyed by focus) — dog page keeps the generic copy.
const CAT_SUB_OVERRIDE: Record<string, string> = {
  Grooming: 'Keep your cat clean and comfortable at home.',
  'Interactive Play': 'Bonding play you and your cat enjoy together.',
};

export const focusSub = (focus: string, pet: Pet): string => (pet === 'Cat' && CAT_SUB_OVERRIDE[focus]) || FOCUS_SUB[focus] || DEFAULT_SUB;

// Per product-type placeholder icon (shown when no product image resolves).
const TYPE_ICON: Record<string, MuiIcon> = {
  Toys: ToysOutlined,
  Chews: PetsOutlined,
  Treats: CookieOutlined,
  'Grooming Tools': ContentCutOutlined,
  Grooming: ContentCutOutlined,
  Health: HealthAndSafetyOutlined,
  'Safety Equipment': ShieldOutlined,
  'Training Equipment': FitnessCenterOutlined,
  'Work to Eat': RestaurantOutlined,
  Cleaning: CleaningServicesOutlined,
  Equipment: CategoryOutlined,
};
export const typeIcon = (type: string): MuiIcon => TYPE_ICON[type] || Inventory2Outlined;

// Product name -> image path. Images live in public/hub/products/.
const IMG: Record<string, string> = {
  'ThunderEase Calming Pheromone Diffuser': '/hub/products/thunderease.png',
  'ThunderShirt Classic Anxiety & Calming Vest': '/hub/products/thundershirt.png',
  'Benebone Wishbone Tough Chew Toy': '/hub/products/benebone.png',
  'Woodies Coffee Wood Large Dog Chew': '/hub/products/woodies.png',
  'KONG Classic Dog Toy': '/hub/products/kong.png',
  'Outward Hound Orbee-Tuff Snoop Treat Dispensing Dog Chew': '/hub/products/snoop.png',
  'Outward Hound Medium Slow Feeder Bowl': '/hub/products/slow-feeder-bowl.png',
  'West Paw Zogoflex Toppl Tough Treat Dispensing Dog Toy': '/hub/products/toppl.png',
  'Multipet Lamb Chop Squeaky Plush Dog Toy': '/hub/products/lamb-chop.png',
  'Nylabone Puppy Pacifier Teething Toy': '/hub/products/nylabone-pacifier.png',
  'Nylabone Teething Ring Puppy Chew Toy': '/hub/products/nylabone-ring.png',
  'Petstages Cool Teething Stick': '/hub/products/teething-stick.png',
  'PET N PET Dog Training Treat Pouch': '/hub/products/treat-pouch.png',
  'Downtown Pet Supply Training Dog Clickers (2 Count)': '/hub/products/clicker.png',
  'Stewart Beef Liver Single Ingredient Freeze-Dried Raw Treats': '/hub/products/stewart-beef-liver.png',
  'Cloud Star Tricky Trainers with Liver Soft & Chewy Dog Treats': '/hub/products/tricky-trainers.png',
  'Pawtitas Reflective Dog Leash, 6-ft long': '/hub/products/leash-6ft.png',
  '2 Hounds Design Freedom No Pull Nylon Dog Harness & Leash': '/hub/products/freedom-harness.png',
  'WAUDOG Waterproof Dog Leash, 10-ft long': '/hub/products/leash-10ft.png',
  'PetSafe Cotton Dog Training Lead, Black, 20-ft long': '/hub/products/leash-20ft.png',
  'Jolly Pets Jolly Egg Dog Toy': '/hub/products/jolly-egg.png',
  'Jolly Pets Push-n-Play Ball': '/hub/products/push-n-play.png',
  'Squishy Face Studio Flirt Pole V2 with Lure Squeaky Dog Toy': '/hub/products/flirt-pole.png',
  'Nerf Dog Squeak Ball Dog Toy': '/hub/products/nerf-ball.png',
  'LickiMat Yoggie Pot BPA-Free Rubber Dog Bowl': '/hub/products/lickimat-yoggie.png',
  'iFetch iDig Stay Dog Toy': '/hub/products/idig.png',
  'ZippyPaws Burrow Squeaky Hide & Seek Plush Dog Toy': '/hub/products/zippypaws-burrow.png',
  'Octagon 6.5 ft. x 7 ft. Wood Sandbox Kit with Cover': '/hub/products/sandbox.png',
  'Pet Parents Forager Snuffle Mat': '/hub/products/snuffle-mat.png',
  'Stashios Soothing Saucer Dog Toy': '/hub/products/soothing-saucer.png',
  'GOOPAWS Silicone Dog Lick Mat (2 Count)': '/hub/products/silicone-lick-mat.png',
  'Woof BullySafe Dog Chew Treat Holder': '/hub/products/woof-bullysafe.png',
  'Best Pet Supplies Oatmeal Unscented Grooming Wipes': '/hub/products/grooming-wipes.png',
  'KONG Dog ZoomGroom Multi-Use Brush': '/hub/products/kong-zoomgroom.png',
  'Rinse Ace Suction Grooming Lick Pad Dog Grooming Tool': '/hub/products/lick-pad.png',
  'Virbac C.E.T. Enzymatic Oral Hygiene Poultry Flavor Dog Dental Kit': '/hub/products/virbac-dental.png',
  'Gentle Creatures Collar Companion - Harness to Collar Safety Clip': '/hub/products/gentle-creatures.png',
  'MidWest iCrate Fold & Carry Single Door Collapsible Wire Crate': '/hub/products/icrate.png',
  'Baskerville Ultra Dog Adjustable Basket Muzzle': '/hub/products/baskerville.png',
  'Pet Gates': '/hub/products/pet-gates.png',
  'Raw Paws Silvervine Sticks Cat Chew Toy (30 Count)': '/hub/products/cat-silvervine-sticks.png',
  'Pet Greens Live Grass Cat Treat (3 Count)': '/hub/products/cat-pet-greens-grass.png',
  'Potaroma Silvervine Stick Cat Chew Toys (6 Count)': '/hub/products/cat-potaroma-silvervine.png',
  'Potaroma Chew Ropes Cat Toy (3 Count)': '/hub/products/cat-potaroma-chew-ropes.png',
  'KONG Cat ZoomGroom Multi-Use Brush': '/hub/products/cat-kong-zoomgroom.png',
  'Catit Senses 2.0 Self Groomer Cat Brush': '/hub/products/cat-catit-self-groomer.png',
  'TRIXIE Self Grooming Arch & Cat Massager': '/hub/products/cat-trixie-arch.png',
  'K&H Pet Products Window Lounger Cat Perch Kitty Window Sill': '/hub/products/cat-kh-window-perch.png',
  'Petlibro Air Wi-Fi Automatic Dog & Cat Feeder': '/hub/products/cat-petlibro-feeder.png',
  'Petlibro Dockstream 2 Smart Stainless Steel Cat Water Fountain': '/hub/products/cat-petlibro-fountain.png',
  'Potaroma Catnip Crinkle Kicker Plush Cat Toy (3 Count)': '/hub/products/cat-potaroma-crinkle-kicker.png',
  'Frisco Foldable Play Tri-Tunnel Cat Toy': '/hub/products/cat-frisco-tritunnel.png',
  'Mad Cat Big Cactus Kicker Catnip & Silvervine Cat Toy': '/hub/products/cat-madcat-cactus.png',
  'Earthtone Solutions Felted Wool Cat Ball Toy (6 Count)': '/hub/products/cat-wool-balls.png',
  'Cat Dancer Cat Charmer Toy (2 Pack)': '/hub/products/cat-charmer.png',
  'Frisco Colorful Springs Cat Toy (40 Count)': '/hub/products/cat-frisco-springs.png',
  'Frisco Bird with Feathers Teaser Wand Cat Toy with Catnip': '/hub/products/cat-frisco-bird-wand.png',
  'Pet Fit For Life Cat Wands Toy': '/hub/products/cat-petfit-wands.png',
  "Nature's Miracle Cat Urine Destroyer Plus Enzymatic Stain Remover Foam Aerosol Spray": '/hub/products/cat-nm-aerosol.png',
  "Nature's Miracle Cat Urine Destroyer Plus Enzymatic Formula Stain Remover": '/hub/products/cat-nm-spray.png',
  'allforpaws Go Fresh Stainless Steel Base Cat Litter Box': '/hub/products/cat-afp-litterbox.png',
  'Tidy Cats Free & Clean Unscented Clumping Clay Cat Litter': '/hub/products/cat-tidy-cats-litter.png',
  'Coziwow Wall Mounted Shelves Set Cat Tree': '/hub/products/cat-coziwow-wall-shelves.png',
  'Necoichi Cozy Cat Scratcher Bowl Toy': '/hub/products/cat-necoichi-bowl.png',
  'Frisco 33-in Heavy Duty Sisal Cat Scratching Post': '/hub/products/cat-frisco-sisal-post.png',
  'Frisco Double-Wide Cat Scratcher Toy with Catnip': '/hub/products/cat-frisco-double-wide.png',
  'PetSafe Come with Me Kitty Nylon Cat Harness & Bungee Leash': '/hub/products/cat-petsafe-harness.png',
  'Downtown Pet Supply Training Clickers (2 Count)': '/hub/products/cat-clicker.png',
  'Whole Life Just One Ingredient Tuna Cat Treat': '/hub/products/cat-wholelife-tuna.png',
  'Inaba Churu Tuna & Chicken Puree Variety Pack Lickable Cat Treat': '/hub/products/cat-inaba-churu.png',
  'PetSafe SlimCat Interactive Cat Feeder': '/hub/products/cat-petsafe-slimcat.png',
  'LickiMat Slomo Non-Skid Thermoplastic Rubber Cat Bowl': '/hub/products/cat-lickimat-slomo.png',
  'Catstages Kitty Cube Cat Interactive Treat Puzzle Toy': '/hub/products/cat-catstages-kitty-cube.png',
  "Doc & Phoebe's Cat Co. Indoor Hunting Cat Feeder Kit": '/hub/products/cat-doc-phoebe-feeder.png',
};
export const resolveImg = (name: string): string | undefined => IMG[name];
